
const Gateway = () => {
  return(
    <div>Gateway</div>
  )
}

export default Gateway